export function ResponsiveLayoutService(
    $window
) {
    const service = this;
    
    let metaTagOriginalContent = '';
    
    service.addResponsiveMetaTag = function addResponsiveMetaTag() {
        const metaTag = $window.document.querySelector('meta[name="viewport"]');
        const metaTagExisted = metaTag != null;

        if (metaTagExisted) {
            metaTagOriginalContent = metaTag.getAttribute('content');
            metaTag.setAttribute('content', 'width=device-width, initial-scale=1');
        } else {
            const newMetaTag = $window.document.createElement('meta');
            newMetaTag.setAttribute('name', 'viewport');
            newMetaTag.setAttribute('content', 'width=device-width, initial-scale=1');
            $window.document.head.appendChild(newMetaTag);
        }
    };

    service.removeResponsiveMetaTag = function removeResponsiveMetaTag() {
        const metaTag = $window.document.querySelector('meta[name="viewport"]');
        if (metaTagOriginalContent !== '') {
            metaTag.setAttribute('content', this.metaTagOriginalContent);
            metaTagOriginalContent = '';
        } else {
            $window.document.head.removeChild(metaTag);
        }
    };
    
    return service;
}

ResponsiveLayoutService.$inject = [
    '$window'
];
